var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.70117C0.5 3.58695 0.942622 2.51837 1.73049 1.73049C2.51837 0.942622 3.58695 0.5 4.70117 0.5H17.3047C18.4189 0.5 19.4875 0.942622 20.2754 1.73049C21.0632 2.51837 21.5059 3.58695 21.5059 4.70117V17.3047C21.5059 18.4189 21.0632 19.4875 20.2754 20.2754C19.4875 21.0632 18.4189 21.5059 17.3047 21.5059H4.70117C3.58695 21.5059 2.51837 21.0632 1.73049 20.2754C0.942622 19.4875 0.5 18.4189 0.5 17.3047V4.70117Z",
    stroke: "#979794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3269 9.95068C8.77706 9.95068 9.95264 8.7751 9.95264 7.32495C9.95264 5.8748 8.77706 4.69922 7.3269 4.69922C5.87675 4.69922 4.70117 5.8748 4.70117 7.32495C4.70117 8.7751 5.87675 9.95068 7.3269 9.95068Z",
    stroke: "#979794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.656 11.6562L4.70117 21.5069H17.4444C18.5215 21.5069 19.5546 21.079 20.3163 20.3173C21.078 19.5556 21.5059 18.5226 21.5059 17.4454V17.3057C21.5059 16.8163 21.3221 16.6283 20.9912 16.2659L16.7585 11.6499C16.5613 11.4347 16.3213 11.263 16.054 11.1457C15.7866 11.0284 15.4978 10.9682 15.2059 10.9688C14.9139 10.9693 14.6253 11.0308 14.3585 11.1491C14.0916 11.2675 13.8524 11.4402 13.656 11.6562Z",
    stroke: "#979794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.fffa7cf63f22aada65b7003d341f50a7.svg";
export { ForwardRef as ReactComponent };